import { CmsService } from './../../services/cms.service';
import { AlertService } from './../../services/alert.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { OverlayService } from './../../services/overlay.service';
import { Store } from './../../store';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-competition-entry',
    templateUrl: './competition-entry.component.html',
    styleUrls: ['./competition-entry.component.scss']
})
export class CompetitionEntryComponent implements OnInit {

    settings$ = this.store.select<any>('settings');
    contactForm: FormGroup;

    contact = {
        firstname: '',
        surname: '',
        email: '',
        telephone: ''
    };

    constructor(
        private store: Store,
        private formBuilder: FormBuilder,
        private overlayService: OverlayService,
        private alertService: AlertService,
        private cmsService: CmsService,
    ) {

    }

    ngOnInit(): void {
        this.contactForm = this.formBuilder.group({
            firstName: ['', [Validators.required, Validators.minLength(3)]],
            lastName: ['', [Validators.required, Validators.minLength(3)]],
            email: ['', [Validators.required, Validators.email, Validators.minLength(5)]],
            phone: ['', [Validators.required, Validators.minLength(8), Validators.pattern(new RegExp('[0-9 ]'))]]
        });

    }

    get field() {
        return this.contactForm.controls;
    }

    onSubmit() {
        if (this.contactForm.invalid) {
            this.contactForm.markAllAsTouched();
            return;
        }

        this.contact.firstname = this.contactForm.controls.firstName.value;
        this.contact.surname = this.contactForm.controls.lastName.value;
        this.contact.email = this.contactForm.controls.email.value;
        this.contact.telephone = this.contactForm.controls.phone.value;

        this.cmsService.sendCompetitionForm(this.contact).subscribe(() => {
            this.contactForm.reset();
            this.close()
            this.alertService.notification(['Thank you for entering.'], 4000);
        });
    }


    close() {
        this.overlayService.closeAll();
    }


}
